export const pageDefaultMenuBtn = document.querySelector('#page-default-menu-btn');
export const pageDefaultMenu = document.querySelector('#nav');
export const galleryModal = document.querySelector('#gallery-modal');
export const galleryModalBtnOpen = document.querySelectorAll('#gallery img');
export const galleryModalBtnClose = document.querySelector('#gallery-modal-btn-close');
export const pageBody = document.querySelector('body');
export const accessibleBtn = document.querySelector('#accessible button');
